exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-query-sampling-cta {\n  align-items: center;\n  color: #2a2a2f;\n  display: flex;\n  flex-direction: column;\n  height: 64px;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: 10px 0;\n  transition: opacity 0.2s ease;\n}\n", ""]);

// exports
